<!-- TODO: Use less module, with variables from themeStyles -->
<ng-template [vbCssRules]="themeStyleOverrides">
</ng-template>
<nav class="main-nav" role="navigation" transitionBackground [transitionBackground]="MainHeaderPosition.isTransparencyActive" [transitionBackgroundClass]="'theme-header-bg theme-accent-border'">

	<section class="navbar">
		<div class="skip-wrap" flex="33">
			<a uiSref="void" class="skip-link" (click)="skipNavigation()">{{ 'SkipToMainContent' | translate }}</a>
			<mobile-menu [hidden]="isRegisteredGuest" [theme]="currentTheme" [headerSettings]="headerSettings" [themeSettings]="themeSettings" [isAnalystAdmin]="isAnalystAdmin" [showManageSubscriptions]="showManageSubscriptions" [landingState]="landingState" [isGuestMode]="isGuestMode">
			</mobile-menu>
		</div>
		<div class="brand-cell" flex="33">


			<div *vbAuthorizationKey="['authenticated', 'distribution.authenticated']">
				<a [attr.aria-label]="('Application_CompanyLogo' | translate) + ' - ' + ('Home' | translate)" class="branding-anchor" href="#/">
					<branding-logo></branding-logo>
				</a>
			</div>
			<div *vbAuthorizationKey="['authenticated', 'distribution.authenticated']; fallback true">
				@if (guestPortalRestricted) {
					<span class="d-block margin-0 padding-0">
						<branding-logo></branding-logo>
					</span>
				}@else {
					<a [attr.aria-label]="('Application_CompanyLogo' | translate) + ' - ' + ('Home' | translate)" [href]="isGuestMode ? '#/' : '/guest'" class="d-block margin-0 padding-0" [tabindex]="0">
						<branding-logo></branding-logo>
					</a>
				}
			</div>
		</div>

		<div class="flexDisplay search right-container" flex="33">
			@if(enableSearch) {
				<ng-container *vbAuthorizationKey="'distribution.authenticated'; fallback true">
					<search-header-dropdown *ngIf="!guestPortalRestricted" role="search">
					</search-header-dropdown>
				</ng-container>
			}

			@if(enableCapture) {
				<a href="/capture" target="capture" class="flex-center-align main-nav-btn line-height-1 text-decoration-none" *vbAuthorizationKey="'media.add'" [title]="'Capture_ScreenRecorder' | translate" [attr.aria-label]="'Capture_ScreenRecorder' | translate">
					<span class="vb-icon vb-icon-capture"></span>
				</a>
			}


			<go-live [bgNone]="true" [dropdownCssClass]="'netrix-dropdown'" [iconCssClass]="'theme-header-txt'" [showRemove]="true">
			</go-live>

			<div class="dropdown upload-cell netrix-dropdown" dropdown vbDropdown #headerUploadMenuDropdown="bs-dropdown" [insideClick]="true" *vbAuthorizationKey="'media.add'">
				<button [attr.aria-label]="('Upload' | translate) + ' - ' + ('UI_Menu' | translate)" class="dropdown-toggle flex-center-align btn main-nav-btn upload bg-none" [ngClass]="{ open: headerUploadMenuDropdown.isOpen}" dropdownToggle>
					<span class="animated theme-header-txt" [ngClass]="{
							'vb-icon vb-icon-center vb-icon-upload': !headerUploadMenuDropdown.isOpen,
							'glyphicons remove_2': headerUploadMenuDropdown.isOpen
						}">
					</span>
				</button>
				<div class="dropdown-menu dropdown-menu-right upload-media" *dropdownMenu>
					<upload-menu (onCloseUploadMenu)="headerUploadMenuDropdown.hide()">
					</upload-menu>
				</div>
			</div>

			<notifications-menu-button *ngIf="isUserAuthenticated" class="notification-cell count-bubble" [alwaysShowIcon]="true" [dropdownCssClass]="'netrix-dropdown'" [glyphiconCssClass]="'theme-header-txt'" [showRemove]="true">
			</notifications-menu-button>
		</div>

	</section>
</nav>
